import styles from "./settings-table-card.module.scss";

interface IProps {
  children: JSX.Element;
}

// Frames a DataTable as a bordered, striped card.
const SettingsTableCard = (props: IProps) => (
  <div className={styles.tableCard}>{props.children}</div>
);

export default SettingsTableCard;
